"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
export default function CompanyDirectory() {
  const currentYear = new Date().getFullYear();
  const products = [{
    label: "Home Inspection",
    href: "/home-inspection-service/"
  }, {
    label: "Wind Mitigation",
    href: "/wind-mitigation-inspection/"
  }, {
    label: "4-Point Inspection",
    href: "/4-point-inspection-in-south-florida/"
  }, {
    label: "Condo Inspection",
    href: "/condo-inspection/"
  }, {
    label: "Mold Testing",
    href: "/mold-testing/"
  }, {
    label: "Pre-Listing Inspection",
    href: "/pre-listing-inspection/"
  }];
  const resources = [{
    label: "Homestead",
    href: "/home-inspection-in-homestead-fl/"
  }, {
    label: "Kendall",
    href: "/kendall-home-inspector/"
  }, {
    label: "Miami",
    href: "/miami-home-inspector/"
  }, {
    label: "Miami-Dade County",
    href: "/miami-dade-county-home-inspector/"
  }, {
    label: "Broward County",
    href: "/broward-county-home-inspector/"
  }, {
    label: "Florida Keys",
    href: "/florida-keys-home-inspector/"
  }];
  const company = [{
    label: "Home",
    href: "/"
  }, {
    label: "Our Services",
    href: "/#our-inspection-services"
  }, {
    label: "About Us",
    href: "/#the-trusted-inspections-advantage"
  }, {
    label: "Schedule Now",
    href: "/#schedule-your-inspection"
  }, {
    label: "Contact Us",
    href: "/#schedule-your-inspection"
  }];
  return <section id="footer" className="dark bg-secondary text-foreground border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          <div className="lg:col-span-1 flex flex-col gap-6">
            <Link to="/" className="block w-fit">
              <WvcLogo className="h-8 w-auto brightness-0 invert" />
            </Link>
            <p className="text-sm text-white/60 leading-relaxed">
              Trusted Inspections is a family‑owned South Florida home inspection company. Licensed and insured, we provide honest, clear residential inspections for home buyers, sellers, and insurance requirements across Miami‑Dade, Broward, the Florida Keys, and premium residential markets such as Coral Gables, South Miami, Palmetto Bay, Pinecrest, Miami Beach, and Fort Lauderdale.
            </p>
            <div className="flex flex-col gap-1 text-sm text-white/60">
              <a href="tel:+17863826895" className="hover:text-primary transition-colors w-fit">
                786-382-6895
              </a>
              <a href="mailto:info@trusted-fl.com" className="hover:text-primary transition-colors w-fit">
                info@trusted-fl.com
              </a>
            </div>
          </div>

          <div className="flex flex-col gap-6">
            <h3 className="font-bold text-white uppercase tracking-widest text-xs">Services</h3>
            <ul className="flex flex-col gap-3">
              {products.map((item, i) => <li key={i} data-index={i}>
                  <Link to={item.href} className="text-sm text-white/60 hover:text-white transition-colors duration-200">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          <div className="flex flex-col gap-6">
            <h3 className="font-bold text-white uppercase tracking-widest text-xs">Locations</h3>
            <ul className="flex flex-col gap-3">
              {resources.map((item, i) => <li key={i} data-index={i}>
                  <Link to={item.href} className="text-sm text-white/60 hover:text-white transition-colors duration-200">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          <div className="flex flex-col gap-6">
            <h3 className="font-bold text-white uppercase tracking-widest text-xs">Quick Links</h3>
            <ul className="flex flex-col gap-3">
              {company.map((item, i) => <li key={i} data-index={i}>
                  <Link to={item.href} className="text-sm text-white/60 hover:text-white transition-colors duration-200">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        <Separator className="my-12 bg-white/10" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-white/40">
          <p>&copy; {currentYear} Trusted Inspections. FL License #HI11452. All rights reserved.</p>
        </div>
      </div>
    </section>;
}